import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type PartyUid = Static<typeof PartyUidSchema>;
export const PartyUidSchema = Type.RegEx(/^[-a-zA-Z0-9]{5,100}$/);
